import { ResponseAuth } from '../types/Response';
import User from '../types/User';

/**
 * Тестовые данные пользователя для режима разработки без backend
 * Используется когда REACT_APP_TEST_USER=true
 */
export const TEST_USER_DATA: ResponseAuth = {
    token: 'test_token_12345678_development_mode',
    patients: [
        {
            id: 'test-patient-001',
            lastName: 'Тестовый',
            firstName: 'Пациент',
            fatherName: 'Тестович',
            birthDay: '1990-01-15',
            email: 'test.patient@example.com',
            phone: '+79991234567',
            validContract: true
        },
        {
            id: 'test-patient-002',
            lastName: 'Тестовый',
            firstName: 'Ребёнок',
            fatherName: 'Тестович',
            birthDay: '2015-06-20',
            email: 'test.child@example.com',
            phone: '+79991234567',
            validContract: true
        }
    ]
};

/**
 * Тестовые данные пользователя для JWT токена
 * Используется для страницы настроек в тестовом режиме
 */
export const TEST_USER_JWT_DATA: User = {
    authorities: ['ROLE_USER'],
    bDay: new Date('1990-01-15'),
    exp: Math.floor(Date.now() / 1000) + (24 * 60 * 60), // токен действителен 24 часа
    fio: 'Тестовый Пациент Тестович',
    iat: Math.floor(Date.now() / 1000),
    userId: 1,
    userEntity: {
        id: -999,
        patientId: -999,
        esia: false,
        login: 'testuser',
        password: 'testpassword',
        firstName: 'Пациент',
        fatherName: 'Тестович',
        birthDay: new Date('1990-01-15'),
        lastLogin: new Date().toISOString(),
        lastName: 'Тестовый',
        gender: true,
        phoneNumber: '+79991234567',
        email: 'test.patient@example.com',
        snils: '123-456-789 00',
        paspNumber: '1234 567890',
        esiaPhoneNumber: '',
        esiaSnils: '',
        esiaEmail: '',
        esiaId: 0,
        esiaRefreshToken: '',
        contactStatus: true,
        token: 'test_token_12345678_development_mode'
    }
};

/**
 * Получает тестовые данные пользователя
 * @returns ResponseAuth объект с тестовыми данными
 */
export const getTestUserData = (): ResponseAuth => {
    // Можно добавить логику для генерации разных тестовых пользователей
    return TEST_USER_DATA;
};

